const requestInit = new Date();

function logWithTime(message) {
  const elapsed = Date.now() - requestInit; // requestInit is your start time in ms
  const seconds = Math.floor(elapsed / 1000);
  const milliseconds = elapsed % 1000;
  console.log(
    `----------- utm-tracking-init log ----------- ${message}: ${seconds}s ${milliseconds}ms`
  );
}

(async () => {
  logWithTime("initializing UTM tracking");

  let landingPage = getLocalstorage("landingPage", false);
  if (!landingPage) {
    landingPage = getCookie("landingPage", false);
  }
  if (!landingPage) {
    landingPage = window.location.href;
  }

  saveToStorage("landingPage", landingPage, true);

  // Get old Utm Data
  let oldLocalStorageUtmData = getLocalstorage("utmData", true) ?? {};
  let oldCookiesUtmData = getCookie("utmData", true) ?? {};

  // Get or generate Visitor/Request UUID
  let [visitorUuid, isFirstVisit] = getVisitorUUID(
    oldLocalStorageUtmData?.visitor_uuid,
    oldCookiesUtmData?.visitor_uuid
  );

  let currentUtmData = getUtmFromParams(visitorUuid) ?? {};
  saveToStorage("request_uuid", currentUtmData.request_uuid, true);
  saveToStorage("visitor_uuid", visitorUuid, true);

  let referrerUtmData = getUtmFromParams(visitorUuid, true);

  referrerUtmData.storageSource = "referrer";
  oldLocalStorageUtmData.storageSource = "localStorage";
  oldCookiesUtmData.storageSource = "cookies";
  currentUtmData.storageSource = "current";

  let bestUtmDataBeforeStape = getBestUtmData(
    referrerUtmData,
    oldLocalStorageUtmData,
    oldCookiesUtmData,
    currentUtmData
  );
  saveToStorage("utmData", JSON.stringify(bestUtmDataBeforeStape), true);
  logWithTime("after save to storage 1");

  // wait up to 250ms second for the Stape process to complete
  const stapeInit = new Date();
  while (new Date() - stapeInit < 250) {
    if (window.stapeComplete === true) {
      break;
    }
    await new Promise((resolve) => setTimeout(resolve, 10));
  }

  let stapeUtms = window.stapeUtms || {};
  if (stapeUtms == null) {
    stapeUtms = {};
  }
  stapeUtms.storageSource = "stape";
  stapeUtms.request_uuid = currentUtmData.request_uuid;
  stapeUtms.visitor_uuid = visitorUuid;
  stapeUtms.landing_page = landingPage;
  stapeUtms.timestamp = new Date().toISOString();

  let bestUtmData = getBestUtmData(
    referrerUtmData,
    oldLocalStorageUtmData,
    oldCookiesUtmData,
    stapeUtms,
    currentUtmData
  );

  bestUtmData.visitor_uuid = visitorUuid;

  window.bestUtmData = bestUtmData;
  window.currentUtmData = currentUtmData;
  window.visitorUuid = visitorUuid;
  window.requestUuid = currentUtmData.request_uuid;

  saveToStorage("utmData", JSON.stringify(bestUtmData), true);

  logWithTime("after save to storage 2");

  const visitData = {
    visitorUuid: visitorUuid,
    localstorageData: oldLocalStorageUtmData,
    cookiesData: oldCookiesUtmData,
    stapeUtms: stapeUtms,
    currentUtmData,
    bestUtmData,
    isFirstVisit,
    landingPage: landingPage,
    referrer: document.referrer,
  };

  function dispatchUtmDataReadyEvent(visitData) {
    const event = new CustomEvent("utmDataReady", { detail: visitData });
    document.dispatchEvent(event);
  }

  if (document.readyState === "loading") {
    // DOM is still loading, wait for it to be ready
    document.addEventListener("DOMContentLoaded", function () {
      window.requestUuid = currentUtmData.request_uuid;
      dispatchUtmDataReadyEvent(visitData);
    });
  } else {
    // DOM is already ready
    dispatchUtmDataReadyEvent(visitData);
  }

  console.log("currentUtmData", currentUtmData);
  window.requestUuid = currentUtmData.request_uuid;
  document.addEventListener("DOMContentLoaded", function () {
    window.requestUuid = currentUtmData.request_uuid;
  });

  await sendVisitorData(visitData);

  async function sendVisitorData(visitData) {
    logWithTime("submitting visit data");

    try {
      const localUrl = "https://localhost:55042/api/visit";
      const prodUrl =
        "https://0vpvfhxhm0.execute-api.us-east-2.amazonaws.com/Prod/api/visit";
      let url = prodUrl;

      if (localStorage.getItem("useLocalApi") === "yes") {
        url = localUrl;
      }

      const bodyJson = JSON.stringify(mapToShopifyVisit(visitData));
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "7fb0dms034n31mci78ew",
        },
        body: bodyJson,
        keepalive: true,
      });

      logWithTime("visit data response");

      if (!response.ok) {
        throw new Error(`Server responded with status ${response.status}`);
      }
    } catch (e) {
      error("Error sending visitor data:", e.message);
    }
  }

  // Function to get the visitor's IP address using an API
  async function getIpAddress() {
    try {
      const response = await fetch("https://api.ipify.org?format=json");
      const data = await response.json();
      return data.ip;
    } catch (e) {
      error("Error getting IP address:", e.message);
      return null;
    }
  }
})();

/**
 * Selects the best UTM data from an array of UTM data objects.
 * Prioritizes non-organic sources and earliest timestamps.
 * @param {...Object} utmDataArray - An array of UTM data objects.
 * @returns {Object} The best UTM data object.
 */
function getBestUtmData(...utmDataArray) {
  let bestUtm = {};
  log("--- utmDataArray ---", utmDataArray);

  const bestUtmData = utmDataArray.find(
    (utm) =>
      !!utm.utm_source &&
      utm.utm_source !== "direct" &&
      utm.utm_source.length > 1
  );
  if (bestUtmData) {
    return bestUtmData;
  }

  return {};
}

function log(message, ...optionalParams) {
  console.log("--- logs ---", message, ...optionalParams);
}

function error(message, ...optionalParams) {
  console.error("--- logs ---", message, ...optionalParams);
}

function getLocalstorage(key, parseJson = false) {
  try {
    const localstorageData = localStorage.getItem(key);
    return parseJson && localstorageData
      ? JSON.parse(localstorageData)
      : localstorageData;
  } catch (e) {
    error("Error getting localstorage data:", e.message);
    return null;
  }
}

function getCookie(key, parseJson = false) {
  try {
    const cookiesData = document.cookie.split(";");
    for (let cookie of cookiesData) {
      const [name, value] = cookie.split("=");
      if (name.trim() === key) {
        return parseJson
          ? JSON.parse(decodeURIComponent(value))
          : decodeURIComponent(value);
      }
    }
    return null;
  } catch (e) {
    error("Error getting cookies data:", e.message);
    return null;
  }
}

function saveToStorage(key, value, overwrite = false) {
  if (isEmpty(value)) {
    return false;
  }

  try {
    // Save to localStorage
    const localValue = localStorage.getItem(key);
    if (localValue === null || overwrite) {
      localStorage.setItem(key, value);
    }

    // Save to cookies
    const cookieValue = getCookie(key, false);
    if (cookieValue === null || overwrite) {
      document.cookie = `${key}=${encodeURIComponent(value)}; path=/`;
    }

    return true;
  } catch (e) {
    error("Error saving to storage:", e.message);
    return false;
  }
}

function getVisitorUUID(uuidLocalStorage, uuidCookies) {
  const oldUuid = uuidLocalStorage || uuidCookies;
  if (oldUuid) {
    return [oldUuid, false];
  }

  const newVisitorId = generateUUID();
  return [newVisitorId, true];
}

function getMainDomainFromUrl(urlStr) {
  try {
    if (!urlStr.startsWith("http://") && !urlStr.startsWith("https://")) {
      const domainRegex =
        /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
      if (domainRegex.test(urlStr)) {
        urlStr = `https://${urlStr}`;
      } else {
        throw new Error("Invalid URL");
      }
    }
    const url = new URL(urlStr);
    const campaign = url.hostname.split(".").slice(-2, -1)[0];
    return campaign;
  } catch (e) {
    console.log(e.message);
    return undefined;
  }
}

function getUtmFromParams(visitorUuid, checkReferrer = false) {
  try {
    const paramsStr = checkReferrer
      ? new URL(document.referrer).search
      : window.location.search;

    const params = new URLSearchParams(paramsStr);
    const utmData = {
      utm_source: params.get("utm_source"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
      utm_term: params.get("utm_term"),
      utm_content: params.get("utm_content"),
      utm_id: params.get("utm_id"),
      timestamp: new Date().toISOString(),
      request_uuid: generateUUID(),
      visitor_uuid: visitorUuid,
      referrer: document.referrer,
      gclid: params.get("gclid"),
      msclkid: params.get("msclkid"),
      fbclid: params.get("fbclid"),
    };

    if (
      checkReferrer &&
      !!utmData.utm_source &&
      utmData.utm_source.length > 1
    ) {
      return utmData;
    } else if (checkReferrer) {
      return {
        visitorUuid: visitorUuid,
      };
    }

    const referrerDomain = getMainDomainFromUrl(document.referrer);
    const isMissingUtmSource = !utmData.utm_source || utmData.utm_source === "";
    if (
      isMissingUtmSource &&
      referrerDomain &&
      referrerDomain !== "modularclosets"
    ) {
      utmData.utm_medium = "organic";
      utmData.utm_source = referrerDomain;
      utmData.utm_campaign = utmData.referrer;
    }

    return utmData;
  } catch (e) {
    return {
      visitorUuid: visitorUuid,
    };
  }
}

function mapToShopifyVisit(data) {
  return {
    // Unique identifiers
    RequestUuid: data?.currentUtmData?.request_uuid || "",
    VisitorUuid: data?.currentUtmData?.visitor_uuid || "",
    VisitorId: localStorage.getItem("mc_visitor_id") || "",
    Timestamp: new Date(data?.currentUtmData?.timestamp || Date.now()),
    CurrentPage: window.location.href,
    landingPage: data?.landingPage,

    Referrer: data?.referrer || null,

    // Current UTM parameters
    UtmSource: data?.currentUtmData?.utm_source || null,
    UtmMedium: data?.currentUtmData?.utm_medium || null,
    UtmCampaign: data?.currentUtmData?.utm_campaign || null,
    UtmTerm: data?.currentUtmData?.utm_term || null,
    UtmContent: data?.currentUtmData?.utm_content || null,
    UtmId: data?.currentUtmData?.utm_id || null,
    Gclid: data?.currentUtmData?.gclid || null,
    Msclkid: data?.currentUtmData?.msclkid || null,
    Fbclid: data?.currentUtmData?.fbclid || null,

    // LocalStorage UTM parameters
    LocalstorageUtmSource: data?.localstorageData?.utm_source || null,
    LocalstorageUtmMedium: data?.localstorageData?.utm_medium || null,
    LocalstorageUtmCampaign: data?.localstorageData?.utm_campaign || null,

    // Cookies UTM parameters
    CookiesUtmSource: data?.cookiesData?.utm_source || null,
    CookiesUtmMedium: data?.cookiesData?.utm_medium || null,
    CookiesUtmCampaign: data?.cookiesData?.utm_campaign || null,

    // Best UTM parameters
    BestUtmSource: data?.bestUtmData?.utm_source || null,
    BestUtmMedium: data?.bestUtmData?.utm_medium || null,
    BestUtmCampaign: data?.bestUtmData?.utm_campaign || null,
    BestUtmTerm: data?.bestUtmData?.utm_term || null,
    BestUtmContent: data?.bestUtmData?.utm_content || null,
    BestUtmId: data?.bestUtmData?.utm_id || null,
    BestUtmTimestamp: data?.bestUtmData?.timestamp || null,
    BestUtmVisitId: data?.bestUtmData?.visitor_uuid || null,
    BestGclid: data?.bestUtmData?.gclid || null,
    BestMsclkid: data?.bestUtmData?.msclkid || null,
    BestFbclid: data?.bestUtmData?.fbclid || null,

    // Stape UTM parameters
    StapeUtmSource: data?.stapeUtms?.utm_source || null,
    StapeUtmMedium: data?.stapeUtms?.utm_medium || null,
    StapeUtmCampaign: data?.stapeUtms?.utm_campaign || null,
  };
}

// Utility function to check if a value is empty
function isEmpty(value) {
  return (
    value === undefined ||
    value === null ||
    value === "" ||
    (Array.isArray(value) && value.length === 0)
  );
}

function generateUUID() {
  const timestamp = Date.now().toString(16);
  const randomHex = () =>
    crypto
      .getRandomValues(new Uint8Array(2))
      .reduce((hex, byte) => hex + byte.toString(16).padStart(2, "0"), "");

  return `${timestamp}-${randomHex()}-${randomHex()}-${randomHex()}-${randomHex()}${randomHex()}`;
}
